<div class="input-container">
  <span class="input-label">Enter Your ZIP or Postal Code</span>
  <div
    class="d-flex postal-code-placeholder"
    (click)="showCampLocationSearchSelect.emit(2)"
  >
    <div style="flex: 1">
      <input
        title="search"
        type="text"
        class="input"
        readonly
      >
    </div>
    <div class="icon-container">
      <img
        src="assets/svg/ico_search.svg"
        alt="Search Icon"
        width="16"
      >
    </div>
  </div>
</div>
<div
  *ngIf="newOpt && isNewOptUnique(newOpt.id)"
  class="input-container"
>
  <span class="input-label">Searched Location</span>
  <div class="location-tile-list-container mt-2">
    <div class="location-tile-container">
      <app-location-tile
        [locationData]="newOpt"
        [isEditMode]="true"
        [isSelected]="newOpt.id === selectedId.value"
        (selectedChange)="changeSelectedLocationTile(newOpt.id)"
      ></app-location-tile>
    </div>
  </div>
</div>
<div class="input-container">
  <span class="input-label">Current Preferred Location</span>
  <div class="location-tile-list-container mt-2">
    <app-location-tile
      *ngFor="let location of myProfileService.locationList$ | async | slice:0:1"
      [locationData]="location"
      [isEditMode]="true"
      [isSelected]="location.id === selectedId.value"
      (selectedChange)="changeSelectedLocationTile(location.id)"
    ></app-location-tile>
  </div>
</div>
<div class="input-container">
  <span class="input-label">Other Visited Locations</span>
  <div class="location-tile-list-container mt-2">
    <span
      *ngIf="(myProfileService.locationList$ | async)?.length === 1"
      class="lato"
    >You have no other visited locations.</span>
    <div
      *ngFor="let location of myProfileService.locationList$ | async | slice:1"
      class="location-tile-container"
    >
      <app-location-tile
        *ngIf="location.id !== myProfileService.preferredLocation.id"
        [locationData]="location"
        [isEditMode]="true"
        [isSelected]="location.id === selectedId.value"
        (selectedChange)="changeSelectedLocationTile(location.id)"
      ></app-location-tile>
    </div>
  </div>
</div>
<div style="margin-top: 5rem;">
  <hr>
  <footer class="flex-sm-row flex-column-reverse row no-gutters footer-action div-footer">
    <div class="col pr-sm-1">
      <button
        class="btn btn-outline-danger btn-block"
        (click)="onCancel()"
      >Cancel</button>
    </div>
    <div class="col pl-sm-1">
      <button
        class="btn btn-danger btn-block ml-sm-1 mb-2"
        (click)="onSave()"
        [disabled]="selectedId.invalid"
      >Save</button>
    </div>
  </footer>
</div>
